import React, { Component } from "react";
import { FaDownload } from "react-icons/fa";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { Link } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import Select from "react-select";
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";

import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  Table,
  Button,
  ModalFooter,
} from "reactstrap";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import filterFactory from "react-bootstrap-table2-filter";
import Breadcrumbs from "components/Common/Breadcrumb";
import { getanalyteevaluationLab } from "store/Payment/actions";
import logo from "../../assets/images/LogoNeqas.jpg";
import "assets/scss/table.scss";
import { Formik, Field, Form, ErrorMessage } from "formik";
// At the top of your file (before the class) or inside the class but outside constructor
const filterInputStyle = {
  textAlign: "center",
  width: "60px", // adjust width to fit table
  margin: "auto",
};

class NewReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDetailModal: false,
      modalData: [], // Detailed results to display
      modalTitle: "", // Optional: show analyte & lab name
      nameFilter: "",
      idFilter: "",
      statusFilter: "", // ✅ add this
      resultFilter: "",
      roundNameFilter: "",
      flattenedReport: [],
      schemeModalOpen: false,
      amountFilter: "",
      discountFilter: "",
      GetAnalyteEvaluationLab: [],
      tableKey: 0,
      feedbackMessage: "",
      totalParticipants: "",
      participantsWithResults: "",
      errorMessage: "",
      editModalOpen: false,
      selectedRow: null,
      analytes: [], // ✅ initialize
      schemes: [], // ✅ initialize
      cycles: [], // ✅ initialize
      rounds: [],
      schemeFilter: "",
      cycleFilter: "",
      analyteFilter: "",
      monthFilter: "",
      lastrunFilter: "",
      acceptedFilter: "",
      rejectedFilter: "",
      warningFilter: "",
      notSubmittedFilter: "",
      totalroundsFilter: "",
      // scheme enrollment status
      schemeFilterStatus: "All",
      roundFilter: "", // ✅ initialize
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",
      feedbackListColumns: [
        {
          dataField: "analyte_name",
          text: "Analytes",
          sort: true,
          style: { textAlign: "left" },
          formatter: (cell, row) => <span>{cell || "-"}</span>,
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.analyteFilter}
                  onChange={(e) => this.handleFilterChange("analyteFilter", e)}
                  className="form-control"
                  style={{
                    filterInputStyle,
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "scheme_name",
          text: "Scheme",
          sort: true,
          style: { textAlign: "center" },
          formatter: (cell, row) => <span>{cell || "-"}</span>,
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.schemeFilter}
                  onChange={(e) => this.handleFilterChange("schemeFilter", e)}
                  className="form-control"
                  style={{
                    filterInputStyle,
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "last_month",
          text: "Last Result Submitted",
          sort: true,
          headerStyle: {
            backgroundColor: "#ebeaaaff", // 🌤 sky blue for header
            textAlign: "center",
          },
          style: {
            backgroundColor: "#ebeaaaff",
            textAlign: "center",
          },
          formatter: (cell) => {
            if (!cell) return "-";

            const dateObj = new Date(cell);
            if (isNaN(dateObj.getTime())) return "-";

            const day = String(dateObj.getDate()).padStart(2, "0");
            const month = dateObj.toLocaleString("en-US", { month: "short" });
            const year = String(dateObj.getFullYear()).slice(-2);

            return `${day}-${month}-${year}`; // e.g., 26-Nov-25
          },
          headerFormatter: (column, colIndex) => (
            <div>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.monthFilter}
                  onChange={(e) => this.handleFilterChange("monthFilter", e)}
                  className="form-control"
                  style={{
                    filterInputStyle,
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "last_evaluation",
          text: "Last Report Status",
          sort: true,
          headerStyle: {
            backgroundColor: "#ebeaaaff", // 🌤 sky blue for header
            textAlign: "center",
          },
          style: {
            backgroundColor: "#ebeaaaff",
            textAlign: "center",
          },
          formatter: (cell) => {
            let color = "black"; // default

            switch ((cell || "").toLowerCase()) {
              case "accepted":
                color = "green";
                break;
              case "warning":
                color = "blue";
                break;
              case "rejected":
                color = "red";
                break;
              case "not submitted":
              case "submitted":
                color = "black";
                break;
              default:
                color = "black";
            }

            return (
              <span style={{ color, fontWeight: "bold" }}>{cell || "-"}</span>
            );
          },
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.lastrunFilter}
                  onChange={(e) => this.handleFilterChange("lastrunFilter", e)}
                  className="form-control"
                  style={{
                    filterInputStyle,
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "total_rounds_registered",
          text: "Total Rounds",
          headerStyle: {
            textAlign: "center",
            backgroundColor: "lightgray", // Light pink for header
          },
          sort: true,
          style: { textAlign: "center", backgroundColor: "lightgray" },
          formatter: (cell, row) => (
            <span
              onClick={() =>
                this.handleCountClick(row, "total_rounds_registered")
              }
            >
              {cell || "-"}
            </span>
          ),
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.totalroundsFilter}
                  onChange={(e) =>
                    this.handleFilterChange("totalroundsFilter", e)
                  }
                  className="form-control"
                  style={{
                    filterInputStyle,
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "accepted",
          text: "Accepted",
          sort: true,
          style: { textAlign: "center" },
          formatter: (cell, row) => (
            <span
              style={{ color: cell ? "green" : "green", fontWeight: "bold" }}
              //
            >
              {cell || "-"}
            </span>
          ),
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.acceptedFilter}
                  onChange={(e) => this.handleFilterChange("acceptedFilter", e)}
                  className="form-control"
                  style={{
                    filterInputStyle,
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "rejected",
          text: "Rejected",
          sort: true,
          style: { textAlign: "center" },
          formatter: (cell, row) => (
            <span
              style={{ color: cell ? "red" : "red", fontWeight: "bold" }}
              // onClick={() => this.handleCountClick(row, "rejected")}
            >
              {cell || "-"}
            </span>
          ),
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.rejectedFilter}
                  onChange={(e) => this.handleFilterChange("rejectedFilter", e)}
                  className="form-control"
                  style={{
                    color: "red",
                    filterInputStyle,
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "warning",
          text: "Warning",
          sort: true,
          style: { textAlign: "center" },
          formatter: (cell, row) => (
            <span
              style={{ fontWeight: "bold" }}
              // onClick={() => this.handleCountClick(row, "warning")}
            >
              {cell || "-"}
            </span>
          ),
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.warningFilter}
                  onChange={(e) => this.handleFilterChange("lwarningFilter", e)}
                  className="form-control"
                  style={{
                    filterInputStyle,
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "not_submitted",
          text: "Not Submitted",
          sort: true,
          style: { textAlign: "center" },
          formatter: (cell, row) => (
            <span
              style={{ color: cell ? "blue" : "blue", fontWeight: "bold" }}
              // onClick={() => this.handleCountClick(row, "not_submitted")}
            >
              {cell || "-"}
            </span>
          ),
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.notSubmittedFilter}
                  onChange={(e) =>
                    this.handleFilterChange("notSubmittedFilter", e)
                  }
                  className="form-control"
                  style={{
                    filterInputStyle,
                  }}
                />
              </div>
            </div>
          ),
        },
      ],
    };
  }
  componentDidMount() {
    const { onGetAnalyteEvaluationLab } = this.props;
    const { user_id } = this.state;

    if (user_id) {
      onGetAnalyteEvaluationLab(user_id);
    }
  }

  fetchData = () => {
    const { onGetAnalyteEvaluationLab } = this.props;
    const { user_id } = this.state;

    if (user_id) {
      onGetAnalyteEvaluationLab(user_id);
    }
  };

  componentDidUpdate(prevProps) {
    const { GetAnalyteEvaluationLab } = this.props;

    if (GetAnalyteEvaluationLab !== prevProps.GetAnalyteEvaluationLab) {
      const rawData = Array.isArray(GetAnalyteEvaluationLab)
        ? GetAnalyteEvaluationLab
        : GetAnalyteEvaluationLab?.data || [];

      const labName = GetAnalyteEvaluationLab?.lab?.name || "-";

      let flat = [];
      let uniqueId = 1;

      rawData.forEach((analyte) => {
        const analyteName = analyte.analyte_name || "-";
        const analyteId = analyte.analyte_id || null;
        const schemes = analyte.schemes || [];

        if (schemes.length === 0) {
          // No schemes for this analyte
          flat.push({
            id: uniqueId++,
            analyte_id: analyteId,
            analyte_name: analyteName,
            scheme_id: null,
            scheme_name: "-",
            enrolled: false,
            last_round: null,
            last_evaluation: "Not Enrolled", // ✅ explicit
            last_month: "-",
            total_rounds_registered: 0,
            accepted: 0,
            warning: 0,
            rejected: 0,
            not_submitted: 0,
            rounds: [],
            lab_name: labName,
          });
        } else {
          schemes.forEach((scheme) => {
            const isEnrolled = scheme.enrolled || false;

            flat.push({
              id: uniqueId++,
              analyte_id: analyteId,
              analyte_name: analyteName,
              scheme_id: scheme.scheme_id || null,
              scheme_name: scheme.scheme_name || "-",
              scheme_type: scheme.scheme_type || "-", // ✅ add scheme type
              enrolled: isEnrolled,
              last_round: scheme.last_round?.round_id || null,
              last_evaluation: isEnrolled
                ? scheme.last_round?.evaluation || "Not Submitted"
                : "Not Enrolled", // ✅ handle not enrolled explicitly
              last_month: isEnrolled ? scheme.last_round?.month || "-" : "-",
              total_rounds_registered: isEnrolled
                ? scheme.total_rounds_registered || 0
                : 0,
              accepted: isEnrolled ? scheme.rounds_summary?.accepted || 0 : 0,
              warning: isEnrolled ? scheme.rounds_summary?.warning || 0 : 0,
              rejected: isEnrolled ? scheme.rounds_summary?.rejected || 0 : 0,
              not_submitted: isEnrolled
                ? scheme.rounds_summary?.not_submitted || 0
                : 0,
              // ⭐ UPDATED TO MAP ROBUST MEAN & Z-SCORE
              rounds: (scheme.rounds || []).map((r) => ({
                ...r,
                robust_mean: r.robust_mean ?? "-",
                z_score: r.z_score ?? "-",

                score: r.score ?? "-",
              })),

              lab_name: labName,
            });
          });
        }
      });

      console.log("Flattened Report with Lab Name & Enrollment:", flat);

      this.setState({ flattenedReport: flat });
    }
  }

  filterData = () => {
    const {
      flattenedReport,
      analyteFilter,
      schemeFilter,
      monthFilter,
      totalroundsFilter,
      lastrunFilter,
      acceptedFilter,
      rejectedFilter,
      warningFilter,
      notSubmittedFilter,
      schemeFilterStatus,
    } = this.state;

    return flattenedReport.filter((row) => {
      // Filter by analyte
      const matchesAnalytes =
        !analyteFilter ||
        (row.analyte_name &&
          row.analyte_name
            .toString()
            .toLowerCase()
            .includes(analyteFilter.toLowerCase()));

      const matchesScheme =
        !schemeFilter ||
        (row.scheme_name &&
          row.scheme_name
            .toString()
            .toLowerCase()
            .includes(schemeFilter.toLowerCase()));

      // Filter by month (last_month column)
      const matchesTotalRounds =
        !totalroundsFilter ||
        (row.total_rounds_registered != null &&
          row.total_rounds_registered.toString().includes(totalroundsFilter));

      const matchesMonth =
        !monthFilter ||
        (row.last_month &&
          row.last_month.toLowerCase().includes(monthFilter.toLowerCase()));

      // Filter by last evaluation (status)
      const matchesLastRun =
        !lastrunFilter ||
        (row.last_evaluation &&
          row.last_evaluation
            .toLowerCase()
            .includes(lastrunFilter.toLowerCase()));

      // Filter by accepted count
      const matchesAccepted =
        !acceptedFilter || row.accepted?.toString().includes(acceptedFilter);

      // Filter by rejected count
      const matchesRejected =
        !rejectedFilter || row.rejected?.toString().includes(rejectedFilter);

      // Filter by warning count
      const matchesWarning =
        !warningFilter || row.warning?.toString().includes(warningFilter);

      // Filter by not submitted count
      const matchesNotSubmitted =
        !notSubmittedFilter ||
        row.not_submitted?.toString().includes(notSubmittedFilter);

      // Filter by enrollment status
      // Filter by enrollment status
      let matchesStatus = true;
      if (schemeFilterStatus && schemeFilterStatus !== "All") {
        if (schemeFilterStatus === "Enrolled") {
          matchesStatus = row.enrolled === true;
        } else if (schemeFilterStatus === "NotEnrolled") {
          // Check if lab is enrolled in any scheme for this analyte
          const allRowsForAnalyte = flattenedReport.filter(
            (r) => r.analyte_id === row.analyte_id && r.lab_id === row.lab_id
          );
          const isEnrolledInAnyScheme = allRowsForAnalyte.some(
            (r) => r.enrolled === true
          );
          matchesStatus = !isEnrolledInAnyScheme; // Only show if not enrolled in any
        }
      }

      return (
        matchesAnalytes &&
        matchesScheme &&
        matchesMonth &&
        matchesLastRun &&
        matchesAccepted &&
        matchesRejected &&
        matchesWarning &&
        matchesNotSubmitted &&
        matchesTotalRounds &&
        matchesStatus
      );
    });
  };
  convertToBase64 = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();

    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  };
  downloadPDF = async () => {
    const doc = new jsPDF("p", "mm", "a4");
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const filteredData = this.filterData();
    const labName =
      filteredData[0]?.lab_name ||
      this.props.GetAnalyteEvaluationLab?.lab?.name ||
      "NHS NEQAS";

    const tableColumns = this.state.feedbackListColumns.map((col) => col.text);
    const tableRows = filteredData.map((item) =>
      this.state.feedbackListColumns.map((col) => item[col.dataField] || "-")
    );

    // -----------------------------------------
    // Convert logo to Base64 and add to PDF
    // -----------------------------------------
    let headerBottom = 10;
    try {
      const imgWidth = 40;
      const imgHeight = 25;
      const x = (pageWidth - imgWidth) / 2;
      const y = 10;

      const base64Logo = await this.convertToBase64(logo);
      doc.addImage(base64Logo, "JPEG", x, y, imgWidth, imgHeight);

      headerBottom = y + imgHeight; // = 35
    } catch (e) {
      console.warn("Logo failed", e);
    }

    // -----------------------------------------
    // Print Date (Top Right)
    // -----------------------------------------
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text(`Print: ${new Date().toLocaleString()}`, pageWidth - 10, 15, {
      align: "right",
    });

    // -----------------------------------------
    // Report Name
    // -----------------------------------------
    doc.setFontSize(15);
    doc.setFont("helvetica", "bold");
    doc.text("Analyte Audit Report", pageWidth / 2, headerBottom + 6, {
      align: "center",
    });

    // -----------------------------------------
    // Lab Name
    // -----------------------------------------
    doc.setFontSize(13);
    doc.text(labName, pageWidth / 2, headerBottom + 16, { align: "center" });

    const tableStartY = headerBottom + 22;

    // Placeholder for page count
    const totalPagesExp = "{total_pages_count_string}";

    // -----------------------------------------
    // TABLE
    // -----------------------------------------
    autoTable(doc, {
      head: [tableColumns],
      body: tableRows,
      startY: tableStartY,
      margin: { bottom: 20 }, // FIX: add more bottom space
      theme: "grid",

      styles: {
        fontSize: 8, // FIX: smaller table text
        halign: "center",
      },

      headStyles: {
        fillColor: [0, 102, 204],
        textColor: 255,
        fontStyle: "bold",
        fontSize: 9,
      },

      columnStyles: {
        0: { halign: "left" },
      },

      // -----------------------------------------
      // CORRECT CENTER FOOTER
      // -----------------------------------------
      didDrawPage: function (data) {
        const pageNumber = doc.internal.getCurrentPageInfo().pageNumber;

        const footerText = "Page " + pageNumber + " / " + totalPagesExp;

        doc.setFontSize(11);
        doc.setFont("helvetica", "bold");

        const xCenter = doc.internal.pageSize.getWidth() / 2;
        const yPos = doc.internal.pageSize.getHeight() - 5;

        doc.text(footerText, xCenter, yPos, { align: "center" });
      },
    });

    // -----------------------------------------
    // Replace placeholder with actual total pages
    // -----------------------------------------
    if (typeof doc.putTotalPages === "function") {
      doc.putTotalPages(totalPagesExp);
    }

    // -----------------------------------------
    // Save File
    // -----------------------------------------
    doc.save("Analyte_Audit_Report.pdf");
  };

  handleCountClick = (row, status) => {
    const rounds = row.rounds || [];
    const isQuantitative = row.scheme_type?.toLowerCase?.() === "quantitative";
    const isQualitative = row.scheme_type?.toLowerCase?.() === "qualitative";
    let modalData = [];

    // Formatter for quantitative values
    const formatNumber = (num) => {
      if (num === null || num === undefined || Number(num) === 0) return "-";
      return parseFloat(Number(num).toFixed(4)).toString();
    };

    if (rounds.length > 0) {
      // -------------------------------------------
      // 1️⃣ NOT SUBMITTED — special handling
      // -------------------------------------------
      if (status.toLowerCase() === "not_submitted") {
        modalData = rounds
          .filter((r) => r.evaluation?.toLowerCase() === "not submitted")
          .map((r) => ({
            round_id: r.round_id || "-",
            round_name: r.round_name || "-",
            result: "-", // always "-"
            units: "-",
            instrument: "-",
            method: "-",
            reagents: "-",
            evaluation: "Not Submitted",
            month: "-",
            robust_mean: "-",
            z_score: "-",
            scheme_type: row.scheme_type,
          }));

        // -------------------------------------------
        // 2️⃣ TOTAL ROUNDS REGISTERED — show all
        // -------------------------------------------
      } else if (status === "total_rounds_registered") {
        modalData = rounds.map((r) => {
          // qualitative: score logic from version 1
          let displayResult = "-";
          if (isQualitative) {
            displayResult =
              r.evaluation?.toLowerCase() === "not submitted" ? "-" : r.score;
          } else {
            displayResult = r.result !== null ? r.result : "-";
          }

          return {
            round_id: r.round_id || "-",
            round_name: r.round_name || "-",
            result: displayResult,
            score: r.score, // keep score
            units: r.units || "-",
            instrument: r.instrument || "-",
            method: r.method || "-",
            reagents: r.reagents || "-",
            evaluation: r.evaluation || "-",
            month: r.month || "-",
            robust_mean: isQuantitative ? formatNumber(r.robust_mean) : "-",
            z_score: isQuantitative ? formatNumber(r.z_score) : "-",
            scheme_type: row.scheme_type,
          };
        });

        // -------------------------------------------
        // 3️⃣ ACCEPTED / REJECTED / WARNING / ETC.
        // -------------------------------------------
      } else {
        modalData = rounds
          .filter((r) => r.evaluation?.toLowerCase() === status.toLowerCase())
          .map((r) => {
            let displayResult = "-";

            if (isQualitative) {
              displayResult =
                r.evaluation?.toLowerCase() === "not submitted" ? "-" : r.score;
            } else {
              displayResult = r.result !== null ? r.result : "-";
            }

            return {
              round_id: r.round_id || "-",
              round_name: r.round_name || "-",
              result: displayResult,
              score: r.score,
              units: r.units || "-",
              instrument: r.instrument || "-",
              method: r.method || "-",
              reagents: r.reagents || "-",
              evaluation: r.evaluation || "-",
              month: r.month || "-",
              robust_mean: isQuantitative ? formatNumber(r.robust_mean) : "-",
              z_score: isQuantitative ? formatNumber(r.z_score) : "-",
              scheme_type: row.scheme_type,
            };
          });
      }
    }

    this.setState({
      showDetailModal: true,
      modalTitle: `${row.analyte_name || "-"} - ${
        row.scheme_name || "-"
      }`,
      modalData,
    });
  };

  prepareTableData = () => {
    const { allLabsData } = this.state;
    const labMap = {};

    allLabsData.forEach((entry) => {
      const key = entry.lab_id;
      if (!labMap[key]) {
        labMap[key] = {
          lab_id: entry.lab_id,
          lab_name: entry.lab_name,
          district: entry.district,
          city: entry.city,
          province: entry.province,
        };
      }

      // Store readable evaluation text
      let evalLabel = "Not Submitted";
      if (entry.result_type === "Acceptable") evalLabel = "Acceptable";
      else if (entry.result_type === "Rejected") evalLabel = "Rejected";
      else if (entry.result_type === "Warning") evalLabel = "Warning";

      labMap[key][entry.analyte] = evalLabel;
    });

    return Object.values(labMap);
  };

  openParticipantModal = (row) => {
    const { GetAnalyteEvaluationLab } = this.state;

    // find all rounds for this participant (lab_id + analyte_id + scheme/cycle)
    const labRounds = (GetAnalyteEvaluationLab || []).filter(
      (entry) =>
        entry.lab_id === row.lab_id &&
        entry.analyte_id === row.analyte_id &&
        entry.scheme_name === row.scheme_name &&
        String(entry.cycle_no) === String(row.cycle_no)
    );

    if (!labRounds.length) {
      console.error("❌ No matching lab rounds found for row:", row);
      return;
    }

    // build participant row
    const participantRow = {
      Analyte: row.analyte_name,
      Scheme: row.scheme_name,
      Cycle: row.cycle_no,
    };

    labRounds.forEach((r, idx) => {
      participantRow[`R ${idx + 1}`] = r.instrument || "-";
    });

    this.setState({
      participantModalOpen: true,
      selectedParticipant: row.lab_name,
      participantRows: [participantRow], // store as array
    });
  };

  handleSchemeModalClose = () => {
    this.setState({
      schemeModalOpen: false,
    });
  };

  handleMouseExit = () => {
    this.setState({
      PatientModal: false,
      MarketerModal: false,
      LabModal: false,
      isHovered: false,
    });
  };
  handleFilterChange = (filterName, e) => {
    const value = e.target.value;
    this.setState({
      [filterName]: value,
      currentPage: 1, // ✅ reset pagination to first page when filter changes
    });
  };

  handleFileChange = (event, setFieldValue) => {
    const file = event.currentTarget.files[0];
    setFieldValue("photo", file);
  };

  getUniqueOptions = (fieldName) => {
    // Always use full data, not filtered
    const allData = this.state.GetAnalyteEvaluationLab || [];
    const options = new Set();

    allData.forEach((item) => {
      const value = item[fieldName];
      if (Array.isArray(value)) {
        value.forEach((v) => options.add(v));
      } else if (value) {
        options.add(value);
      }
    });

    return Array.from(options);
  };

  render() {
    const { GetAnalyteEvaluationLab } = this.state;
    const defaultSorted = [{ dataField: "id", order: "desc" }];

    const filteredData = this.filterData();

    const totalParticipants = filteredData.length;
    const participantsWithResults = filteredData.filter(
      (lab) => lab.result_value !== null && lab.result_value !== undefined
    ).length;
    const pageOptions = {
      sizePerPage: 10000,
      totalSize: filteredData.length,
      custom: true,
      page: this.state.currentPage || 1,
      onPageChange: (page) => {
        this.setState({ currentPage: page });
      },
    };
    const schemeType =
      this.state.reportScheme?.analytetype?.toLowerCase() || "";

    // ✅ Step: Conditionally include the "Round" column
    let visibleColumns = [...this.state.feedbackListColumns];

    // Remove or include "Round" column dynamically

    const allColumns = [...visibleColumns];

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Analyte Report | NHS NEQAS</title>
          </MetaTags>

          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs title="Labs" breadcrumbItem="Analyte Audit Report" />
            <Row className="mb-3">
              <Col className="text-end">
                <Button color="primary" onClick={this.downloadPDF}>
                  <FaDownload /> Download PDF
                </Button>
              </Col>
            </Row>

            <Row className="justify-content-center align-item-center">
              <Col lg="10">
                {" "}
                <Card>
                  <CardBody>
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="id"
                      columns={this.state.feedbackListColumns}
                      data={this.filterData()}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          columns={allColumns}
                          data={this.filterData()}
                          search
                        >
                          {(toolkitprops) => (
                            <React.Fragment>
                              <Row className="mb-3">
                                <p>
                                  <strong>Note:</strong>
                                </p>
                                <p>
                                  1: This data is only for Schemes with active
                                  Cycles.
                                </p>
                                <p>
                                  2: Move your cursor over the total rounds to
                                  see the details of submitted results.
                                </p>
                              </Row>
                              <Row className="mb-3">
                                <Col md={4}>
                                  <Label>Scheme Status</Label>
                                  <Select
                                    options={[
                                      { value: "All", label: "All" },
                                      { value: "Enrolled", label: "Enrolled" },
                                      {
                                        value: "NotEnrolled",
                                        label: "Not Enrolled",
                                      },
                                    ]}
                                    onChange={(selectedOption) =>
                                      this.setState({
                                        schemeFilterStatus:
                                          selectedOption.value,
                                      })
                                    }
                                    value={
                                      this.state.schemeFilterStatus
                                        ? {
                                            value:
                                              this.state.schemeFilterStatus,
                                            label:
                                              this.state.schemeFilterStatus ===
                                              "All"
                                                ? "All"
                                                : this.state
                                                    .schemeFilterStatus ===
                                                  "Enrolled"
                                                ? "Enrolled"
                                                : "Not Enrolled",
                                          }
                                        : null
                                    }
                                  />
                                </Col>
                              </Row>
                              <Modal
                                isOpen={this.state.showDetailModal}
                                toggle={() =>
                                  this.setState({ showDetailModal: false })
                                }
                                size="xl"
                              >
                                <ModalHeader
                                  toggle={() =>
                                    this.setState({ showDetailModal: false })
                                  }
                                >
                                  {this.state.modalTitle}
                                </ModalHeader>
                                <ModalBody>
                                  <Table bordered>
                                    <thead>
                                      <tr>
                                        {/* <th>Month</th> */}
                                        <th>Round</th>
                                        <th>Result</th>
                                        {/* 🔥 Conditionally show ONLY if quantitative */}
                                        {this.state.modalData[0]?.scheme_type?.toLowerCase() ===
                                          "quantitative" && (
                                          <>
                                            <th>Units</th>
                                            <th>Robust Mean</th>
                                            <th>Z-Score</th>
                                          </>
                                        )}
                                        <th>Instrument</th>
                                        <th>Method</th>
                                        <th>Reagents</th>
                                        <th>Evaluation</th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {this.state.modalData.map(
                                        (row, index) => {
                                          let evalColor = "black"; // default

                                          if (row.evaluation) {
                                            switch (
                                              row.evaluation.toLowerCase()
                                            ) {
                                              case "accepted":
                                                evalColor = "green";
                                                break;
                                              case "rejected":
                                                evalColor = "red";
                                                break;
                                              case "warning":
                                                evalColor = "blue";
                                                break;
                                              case "not submitted":
                                                evalColor = "black";
                                                break;
                                              default:
                                                evalColor = "black";
                                            }
                                          }

                                          return (
                                            <tr key={index}>
                                              {/* <td>{row.month}</td> */}
                                              <td>{`R${index + 1}`}</td>
                                              <td>
                                                {row.scheme_type?.toLowerCase() ===
                                                "qualitative"
                                                  ? row.score ?? "-"
                                                  : row.result ?? "-"}
                                              </td>
                                              {row.scheme_type?.toLowerCase() ===
                                                "quantitative" && (
                                                <>
                                                  <td>{row.units}</td>
                                                  <td>{row.robust_mean}</td>
                                                  <td>{row.z_score}</td>
                                                </>
                                              )}
                                              <td>{row.instrument}</td>
                                              <td>{row.method}</td>
                                              <td>{row.reagents}</td>
                                              <td
                                                style={{
                                                  color: evalColor,
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                {row.evaluation}
                                              </td>
                                            </tr>
                                          );
                                        }
                                      )}
                                    </tbody>
                                  </Table>
                                </ModalBody>

                                <ModalFooter>
                                  <Button
                                    color="secondary"
                                    onClick={() =>
                                      this.setState({ showDetailModal: false })
                                    }
                                  >
                                    Close
                                  </Button>
                                </ModalFooter>
                              </Modal>

                              <Row className="mb-4">
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      {...toolkitprops.baseProps}
                                      {...paginationTableProps}
                                      defaultSorted={defaultSorted}
                                      classes={
                                        "table align-middle table-condensed"
                                      }
                                      bordered={false}
                                      striped={false}
                                      headerWrapperClasses={
                                        "table-header-sky-blue"
                                      }
                                      responsive
                                      ref={this.node}
                                      filter={filterFactory()}
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

NewReport.propTypes = {
  GetAnalyteEvaluationLab: PropTypes.array,
  GetAnalyteEvaluationLab: PropTypes.object.isRequired,
  onGetAnalyteEvaluationLab: PropTypes.func,
  match: PropTypes.object,
};

const mapStateToProps = ({ AddPayment }) => ({
  GetAnalyteEvaluationLab: AddPayment.GetAnalyteEvaluationLab,
});

const mapDispatchToProps = (dispatch) => ({
  onGetAnalyteEvaluationLab: (id) => dispatch(getanalyteevaluationLab(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewReport);
